import React from 'react';
import logo from './woven.svg';
import './App.css';
import Header from './components/Header';
import Section from './components/Section';
import Paper from '@mui/material/Paper';
import { EMPLOYMENT_HISTORY } from './data/career';
import EmployerCard from './components/EmployerCard';

function App() {
  return (
    <div className="App">
      <Header />
      {
      // <Section title="Work Experience">
      //   { EMPLOYMENT_HISTORY.map((employer) => {
      //     return <EmployerCard employer={employer} />
      //   }) }
      // </Section>
      // <Section title="Education">
      //   <p>zib</p>
      //   <p>zub</p>
      // </Section>
      // <Section title="Skills">
      //   <p>ding</p>
      //   <p>dong</p>
      // </Section>
      }
    </div>
  );
}

export default App;
